// /js/common/header.js
import { gsap } from "@/js/common/gsap.js";

document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("[data-menu-toggle]");
  const panel = document.querySelector("[data-menu-panel]");

  if (!btn || !panel) return;
  if (btn.__menuBound) return;

  btn.__menuBound = true;

  const btnText = btn.querySelector(".c-ham-btn__text");
  const navItems = panel.querySelectorAll(".p-global-nav__item");

  const PC_QUERY = "(min-width: 1024px)";
  const HTML_OPEN_CLASS = "is-menu-open";
  const BODY_FIXED_CLASS = "is-fixed";

  const mql = window.matchMedia(PC_QUERY);

  const state = {
    open: false,
  };

  const isPC = () => mql.matches;

  if (!panel.id) {
    panel.id = "site-menu";
  }

  btn.setAttribute("aria-controls", panel.id);
  btn.setAttribute("aria-expanded", "false");
  btn.setAttribute("aria-label", "メニューを開く");

  panel.setAttribute("aria-hidden", "true");
  panel.setAttribute("inert", "");

  const applyBodyLock = (lock) => {
    document.documentElement.classList.toggle(HTML_OPEN_CLASS, lock);
    document.body.classList.toggle(BODY_FIXED_CLASS, lock);
  };

  const resetNavItems = () => {
    gsap.killTweensOf(navItems);

    gsap.set(navItems, {
      autoAlpha: 0,
      x: 20,
    });
  };

  const showNavItems = () => {
    gsap.killTweensOf(navItems);

    gsap.fromTo(
      navItems,
      {
        autoAlpha: 0,
        x: 20,
      },
      {
        autoAlpha: 1,
        x: 0,
        duration: 0.25,
        stagger: 0.1,
        ease: "power1.out",
        delay: 0.1,
      }
    );
  };

  const updateButton = () => {
    btn.hidden = isPC();
    btn.disabled = false;

    btn.setAttribute("aria-expanded", String(state.open));
    btn.setAttribute(
      "aria-label",
      state.open ? "メニューを閉じる" : "メニューを開く"
    );

    if (btnText) {
      btnText.textContent = state.open ? "CLOSE" : "MENU";
    }
  };

  const showPCMenu = () => {
    state.open = false;

    btn.hidden = true;
    btn.disabled = false;
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "メニューを開く");

    if (btnText) {
      btnText.textContent = "MENU";
    }

    panel.classList.add("is-open");
    panel.removeAttribute("aria-hidden");
    panel.removeAttribute("inert");

    applyBodyLock(false);

    gsap.killTweensOf(navItems);
    gsap.set(navItems, {
      autoAlpha: 1,
      x: 0,
      clearProps: "all",
    });
  };

  const showSPMenu = () => {
    updateButton();

    panel.classList.toggle("is-open", state.open);
    panel.setAttribute("aria-hidden", String(!state.open));

    if (state.open) {
      panel.removeAttribute("inert");
      showNavItems();
    } else {
      panel.setAttribute("inert", "");
      resetNavItems();
    }

    applyBodyLock(state.open);
  };

  const reflectUI = () => {
    if (isPC()) {
      showPCMenu();
      return;
    }

    showSPMenu();
  };

  const openMenu = () => {
    if (isPC() || state.open) return;

    state.open = true;
    reflectUI();
  };

  const closeMenu = () => {
    if (isPC() || !state.open) return;

    state.open = false;
    reflectUI();
  };

  const toggleMenu = () => {
    state.open ? closeMenu() : openMenu();
  };

  const resetMenu = () => {
    state.open = false;
    reflectUI();
  };

  btn.addEventListener("click", (e) => {
    e.preventDefault();

    if (isPC()) return;

    toggleMenu();
  });

  panel.addEventListener("click", (e) => {
    if (isPC() || !state.open) return;

    const link = e.target.closest("a");

    if (!link) return;

    const href = link.getAttribute("href");

    if (!href || href === "#") {
      e.preventDefault();
    }

    closeMenu();
  });

  document.addEventListener("click", (e) => {
    if (isPC() || !state.open) return;

    if (!panel.contains(e.target) && !btn.contains(e.target)) {
      closeMenu();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (isPC() || !state.open) return;

    if (e.key === "Escape") {
      closeMenu();
    }
  });

  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", resetMenu);
  } else {
    mql.addListener(resetMenu);
  }

  reflectUI();

  window.addEventListener("pageshow", resetMenu);
});